import { render, staticRenderFns } from "./fl44-external-purchase-card.vue?vue&type=template&id=635325fd&scoped=true&"
import script from "./fl44-external-purchase-card.vue?vue&type=script&lang=js&"
export * from "./fl44-external-purchase-card.vue?vue&type=script&lang=js&"
import style0 from "./fl44-external-purchase-card.vue?vue&type=style&index=0&id=635325fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635325fd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('635325fd')) {
      api.createRecord('635325fd', component.options)
    } else {
      api.reload('635325fd', component.options)
    }
    module.hot.accept("./fl44-external-purchase-card.vue?vue&type=template&id=635325fd&scoped=true&", function () {
      api.rerender('635325fd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl44-contracts/partials/fl44-external-purchase-card.vue"
export default component.exports